import React, { useEffect, useState } from 'react';
import classes from "./Leaderboard.module.css";
import Header from '../components/Header';
import BottomNavbar from '../components/BottomNavbar';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft } from "react-icons/fa6";
import Lottie from 'lottie-react';
import leaderboardAnimation from "../animations/leaderboardAnimation.json";
import { getLeaderboard } from '../http/http';
import { useDispatch, useSelector } from 'react-redux';
import MediumLoader from '../components/Loaders/MediumLoader';
import { useTranslation } from 'react-i18next';
import { removeUserToken } from '../store/slices/userTokenSlice';
import { toast } from 'react-toastify';

const Leaderboard = () => {
    const navigate = useNavigate();
    const [leaderBoardList, setLeaderBoardList] = useState([]);
    const { userToken } = useSelector(state => state.persisted.userTokenSlice);
    const [loading, setLoading] = useState(true);
    const dispatch = useDispatch();

    const { t } = useTranslation();

    const { selectedLanguage } = useSelector(state => state.languageSlice);

    const fetchLeaderboard = async () => {
        try {
            setLoading(true);
            const response = await getLeaderboard(userToken);
            setLeaderBoardList(response?.data?.result);
            setLoading(false);
        } catch (error) {

            if (error?.response?.status == 403) {
                dispatch(removeUserToken());
                toast.error(t("52"));
                navigate('/');
            }
            else {
                toast.error(error?.response?.data?.error?.error || error?.response?.error?.error || error?.response?.error || "Something Went Wrong!");
            }
        }
    }

    useEffect(() => {
        fetchLeaderboard();
    }, [])
    return (
        <>
            <Header />

            <div className={classes.container}>

                <div className={classes.header_section}>
                    <div className={classes.back_button} onClick={() => {
                        navigate(-1);
                    }}>
                        <FaArrowLeft className={classes.back_icon} />
                    </div>

                    <h2 className={classes.header_text}>{t("55")}</h2>
                </div>

                <div className={classes.leaderboard_container}>
                    <Lottie animationData={leaderboardAnimation} loop autoPlay className={classes.leaderboard_animation} />
                    {loading ? <MediumLoader /> :
                        leaderBoardList?.map((user, index) => {
                            return (
                                <div className={classes.leaderboard_item} key={index}>
                                    <div className={classes.leaderboard_section_one}>
                                        <div className={classes.user_profile_container}>
                                            <img src={user?.image || "assets/images/dummy.png"} alt="User" className={classes.user_profile_image} />
                                            <span className={classes.rank_badge}>{index + 1}</span>
                                        </div>

                                        <div className={classes.user_details_container}>
                                            <h4 className={classes.user_name}>{user?.name || t("17")}</h4>
                                            <p className={classes.user_score}><b>{t("18")}</b> {user.total_points}  </p>
                                        </div>

                                    </div>


                                    <div className={classes.user_points_container}>
                                        <img src="assets/images/tag.png" alt="Tag" className={classes.tag_image} />
                                        <span className={classes.user_points}>
                                            {user.total_points}
                                        </span>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            </div >

            <BottomNavbar active={3} />
        </>
    )
}

export default Leaderboard